import dayjs from 'dayjs'

import ProductReview from '@/ts/interfaces/product/ProductReview'

import Rating from '../Rating'

function ReviewTile({ review }: ReviewTileProps) {
  return (
    <div className="px-5 py-3 mb-4 overflow-hidden rounded-md bg-sbtviolet-100">
      <div className="flex flex-col space-y-2">
        <h2 className="font-medium text-sbtviolet-600">
          {review?.user_name && (
            <span className="mr-2">{review.user_name}</span>
          )}
          <span className="text-xs text-sbtgray-350 ">
            {dayjs(review.created_at).format('HH:mm, DD.MM.YYYY')}
          </span>
        </h2>
        <Rating rating={review.rating} />
      </div>
      {review?.opinion?.trim().length > 0 && (
        <span className="block mt-4 overflow-hidden text-sm">
          {review.opinion}
        </span>
      )}
    </div>
  )
}

interface ReviewTileProps {
  review: ProductReview
}

export default ReviewTile
